import React from 'react'

function AppFooter() {
  return (
    <div></div>
  )
}

export default AppFooter